import React, { Component } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import pluralize from 'pluralize'
import { Card } from 'semantic-ui-react'

import ExpandIcon from 'Components/ExpandIcon'
import ReservationEvent from 'Components/ReservationEvent'
import ReservationSection from 'Components/ReservationSection'

import { getCurrent, getRecent, getUpcoming } from 'Global/Helpers/reservationHelpers'

class ReservationsCard extends Component {
  static propTypes = {
    isEditable: PropTypes.bool,
    reservations: PropTypes.array.isRequired,
    showEditReservationModal: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isEditable: true,
  }

  state = {
    expanded: false,
  }

  toggleExpand = () => {
    const { expanded } = this.state

    this.setState({ expanded: !expanded })
  }

  render() {
    const { isEditable, reservations, showEditReservationModal } = this.props
    const { expanded } = this.state

    const current = getCurrent(reservations) && (
      <ReservationEvent
        editable={isEditable}
        reservation={getCurrent(reservations)}
        showEditReservationModal={showEditReservationModal}
        current
      />
    )

    const recent = getRecent(reservations)
      .sort((a, b) => moment.utc(a.dateFrom).diff(moment.utc(b.dateFrom)))
      .map(r => <ReservationEvent editable={false} key={r.id} reservation={r} />)

    const upcoming = getUpcoming(reservations)
      .sort((a, b) => moment.utc(a.dateFrom).diff(moment.utc(b.dateFrom)))
      .map(r => <ReservationEvent editable={isEditable} key={r.id} reservation={r} showEditReservationModal={showEditReservationModal} />)

    return (
      <div>
        {(current || recent.length > 0 || upcoming.length > 0) && (
          <div>
            <Card color={current ? 'orange' : 'green'} fluid raised>
              {current && <ReservationSection title="Current Reservation">{current}</ReservationSection>}

              {upcoming.length > 0 && (
                <ReservationSection title={current ? 'Upcoming' : `Upcoming ${pluralize('Reservation', upcoming.length)}`}>
                  {upcoming}
                </ReservationSection>
              )}

              {recent.length > 0 && (
                <ReservationSection
                  title={!current && upcoming.length === 0 ? `Recent ${pluralize('Reservation', recent.length)}` : 'Recent'}
                >
                  {(current || upcoming.length > 0) && recent.length > 0 && (
                    <ExpandIcon expanded={expanded} toggleExpand={this.toggleExpand} />
                  )}

                  {!current && upcoming.length === 0 && <ExpandIcon expanded={expanded} toggleExpand={this.toggleExpand} />}

                  {expanded && recent.length > 0 && <div>{recent}</div>}
                </ReservationSection>
              )}
            </Card>
          </div>
        )}
      </div>
    )
  }
}

export default ReservationsCard
